<script setup>
import { TakePaginationEnumerator } from '@/enums/common';

const emit = defineEmits(['update:modelValue']);

const props = defineProps({
  modelValue: {
    type: Number,
    default: 0,
  },
});

function selectValue(option) {
  emit('update:modelValue', option);
}

defineExpose([props]);
</script>

<template>
  <select name="selectTake" class="form-select px-2 ms-1" @change="selectValue($event.target.value)">
    <option v-for="take in TakePaginationEnumerator" :key="take.valueEnum" :value="take.valueEnum">{{ take.descriptionEnum }}</option>
  </select>
</template>
